import { getErrorMessage } from '../../Shared/errorHandling';
import { JSONSchema7 } from 'json-schema';
import { post } from '../../Shared/ajax';
import { useContext } from 'react';
import { useSnackbar } from 'notistack';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext
} from '../../WorkflowEngine/workflowEngineReducer';
import getControlsFromPageSchema from '../../Shared/jsonSchemaUtilities/getControlsFromPageSchema';
import isBuilding from '../../Shared/jsonSchemaUtilities/isBuilding';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Document as DocumentIcon } from '@abbott-components/icons';
import Tooltip from '@mui/material/Tooltip';

interface AddDynamicWorkflowVersionPageResponse {
  pageExternalId: string;
  pageMetadata: string;
  pageOrder: number;
}

interface AddDynamicWorkflowVersionPageRequest {
  workflowVersionExternalId: string;
}

export default () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);

  const { versionExternalId } = state;

  const { enqueueSnackbar } = useSnackbar();

  const handleAddNewPageClick = async () => {
    if (isBuilding(state.pages)) {
      enqueueSnackbar('One control can be built at a time.', {
        variant: 'warning'
      });
      return;
    }

    try {
      const response = await post<
        AddDynamicWorkflowVersionPageResponse,
        AddDynamicWorkflowVersionPageRequest
      >(`dynamicworkflowversion/${versionExternalId}/page`, {
        workflowVersionExternalId: versionExternalId
      });

      const schema = JSON.parse(response.pageMetadata) as JSONSchema7;
      const controls = getControlsFromPageSchema(
        response.pageExternalId,
        schema
      );

      // set new page control to building mode
      controls[0].building = true;

      enqueueSnackbar('A new page was successfully saved into the workflow!', {
        variant: 'success'
      });

      dispatch({
        type: WorkflowEngineActionKind.ADD_PAGE,
        payload: {
          id: response.pageExternalId,
          schema,
          controls
        }
      });
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' });
    }
  };

  return (
      <Tooltip title="New Page" placement="right" disableInteractive>
    <ListItemButton onClick={handleAddNewPageClick}>
      <ListItemIcon style={{ minWidth: 'auto' }}>
        <DocumentIcon />
      </ListItemIcon>
    </ListItemButton>
    </Tooltip>
  );
};
